var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleMeetColored = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "Google Meet",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ea4335",
  d: "M166 106v90H76"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffba00",
  d: "M166 106v90h120v62l90-73v-49q0-30-30-30"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#00ac47",
  d: "M164 406v-90h122v-60l90 71v49q0 30-30 30"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#00832d",
  d: "m286 256 90-73v146"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#00ac47",
  d: "m376 183 42-34c9-7 18-7 18 7v200c0 14-9 14-18 7l-42-34"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#0066da",
  d: "M76 314v62q0 30 30 30h60v-92"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#2684fc",
  d: "M76 196h90v120H76"
})));
export default SvgGoogleMeetColored;